// Use the same base for dev & prod; both are proxied to the backend
export const API_BASE = "/api";

export const ENDPOINTS = {
  AUTH: { LOGIN: "/admin/auth/login" },
  // add others here
};
